// Authored by GLM 5.3 through OpenCode Go; reviewed with Matthew, Hermes and unslop.
export const streakCopy = {
  inARow: n => `${n} practice nights in a row`,
  practiceDay: n => `${n} completed sessions`,
}
